import { apiFetch } from '@/api/client'

const multipart = { 'Content-Type': 'multipart/form-data' }

export const onboardingApi = {
  masterQuestions: (params) => apiFetch('master-questions', { params }),
  answerFromFile: (formData) =>
    apiFetch('workspaces/setup/answer-from-file', { method: 'POST', body: formData, headers: multipart }),
  setupWorkspace: (formData) =>
    apiFetch('workspaces/setup', { method: 'POST', body: formData, headers: multipart }),
}
